import { Button } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation";

interface IDemoActionsProps {
    onCancel: () => void;
    onConfirm: () => void;
}

export const DemoActions = ({ onCancel, onConfirm }: IDemoActionsProps) => {
    const translate = useTranslation();
    return (
        <>
            <Button
                type="flat"
                onClick={onCancel}
            >
                {translate("monitor_and_protect.shared.alerts_modal.demo_see_all_campaigns_button")}
            </Button>
            <Button onClick={onConfirm}>
                {translate("monitor_and_protect.shared.alerts_modal.demo_close_button")}
            </Button>
        </>
    );
};
